var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavOff(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5349 3.50292C19.0707 3.02645 18.5194 2.64848 17.9128 2.39061C17.3061 2.13273 16.6558 2 15.9991 2C15.3424 2 14.6921 2.13273 14.0854 2.39061C13.4787 2.64848 12.9275 3.02645 12.4633 3.50292L11.4998 4.49131L10.5363 3.50292C9.5985 2.54094 8.32662 2.0005 7.00043 2.0005C5.67423 2.0005 4.40235 2.54094 3.46459 3.50292C2.52683 4.46491 2 5.76964 2 7.1301C2 8.49055 2.52683 9.79529 3.46459 10.7573L4.42808 11.7457L10.0363 17.4988C10.8385 18.3216 12.1611 18.3216 12.9632 17.4988L18.5714 11.7457L19.5349 10.7573C19.9994 10.281 20.3678 9.71557 20.6192 9.09321C20.8706 8.47084 21 7.80377 21 7.1301C21 6.45642 20.8706 5.78935 20.6192 5.16699C20.3678 4.54463 19.9994 3.97917 19.5349 3.50292Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavOff);
export default __webpack_public_path__ + "static/media/fav-off.088ca0741f694af09e572ff569cd7c2a.svg";
export { ForwardRef as ReactComponent };